import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, setLocalInfo, setStoreName, camelcase, formatDate } from '@/common/js/utils'

export default {
  computed: {
    ...mapGetters('Convert', ['currentRoute'])
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: parseInt(getLocal('PAGESIZE')) || 10,
      total: 0,
      balancing: false, // 账户余额状态
      balance: '',
      collapsible: null // 展开过滤器
    }
  },
  methods: {
    sortTable(params) {
      const { sort, order } = params
      this.sort = sort
      this.order = order
      this.pageIndex = 1
      this.getData()
    },
    setLocalPage(size) {
      setLocal('PAGESIZE', size)
    },
    searchFilterData(params) {
      this.pageIndex = 1
      this.getData(params)
      this.mainVal && this.getBalance(params)
    },
    filterData(params) {
      this.pageIndex = 1
      this.getData(params)
      this.mainVal && this.getBalance(params)
    },
    // 自定义列
    selectColumn(params) {
      const columns = params.sort((a, b) => (a._time || 0) - (b._time || 0))
      this.$set(this, 'columns', columns)
      this.modalColumn = false
    },
    headerDragend({ n, column }) {
      const index = this.columns.findIndex(ret => ret.key === column.property)
      index > -1 && this.$set(this.columns[index], 'width', n)
    },
    getCustomStorage(name) {
      const account = Cookies.get('ch_op_id')
      const storage = getLocal(name)
      if (storage && isArray(storage[account])) return storage[account]
      else return []
    },
    setCustomStorage(name, list) {
      const account = Cookies.get('ch_op_id')
      let storage = getLocal(name)
      if (!storage) storage = {}
      storage[account] = list
      setLocal(name, storage)
    },
    openNewEntry() {
      window.open('/create-plan/toutiao/template', '_blank')
    }
  },
  filters: {
    adTouTime: (cellValue, row) => {
      let timer
      const start = formatDate(new Date(row.adStartTime), 'yyyy-MM-dd')
      const end = formatDate(new Date(row.adEndTime), 'yyyy-MM-dd')
      if (row.adStartTime && row.adEndTime) timer = `${start} ~ ${end}`
      else timer = '不限'
      return timer
    }
  }
}
